/**
 * Fit view
 * @param geometry
 * @param padding
 * @param maxZoom
 * @param duration
 */
export function viewFit(geometry, padding = undefined, maxZoom = undefined, duration = undefined) {

    if(window.view) {
        setTimeout(function () {
            window.view.fit(geometry, {
                padding: padding,
                maxZoom: maxZoom,
                duration: duration
            });
        }, 0)
    }
}
